module.exports = __webpack_public_path__ + "static/home-numbers-image-e98185b48c1e0df9d6cd68c85223a7e3.png";